import { createContext, useContext } from "react";

// Optional container for Radix portals (Tooltip / Dialog). Defaults to null, so Radix falls back to
// document.body. The AI chat supplies an external window's body while it is popped out.
export const PortalContainerContext = createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement | null {
  return useContext(PortalContainerContext);
}
